module.exports = __webpack_public_path__ + "static/img/banner-2.88e495a2.png";